module.exports = __webpack_public_path__ + "static/TT1394_TW-MARK-M03_r1-clean-981a68b20031cbecc3587aa963c3ad07.png";